import { ProfileRequest } from './../utils/api/requests/ProfileRequest';
import { makeObservable, action, runInAction, observable } from 'mobx';
import { ITimeZone, Store } from '@utils';
import { Inject, Service } from 'typedi';

@Service()
export class TimeZonesStore extends Store<ITimeZone> {
  @Inject(() => ProfileRequest)
  private profileRequest: ProfileRequest;

  constructor() {
    super();
    makeObservable(this);
  }

  @action getTimeZones = () => {
    return this.profileRequest.getTimeZonesList()
      .then((resp) => runInAction(
        () => this.data = resp.data.map((elem) => ({ 
          ...elem, 
          minutesOffset: this.getMinutesOffset(elem.zoneOffset)
        }))
      ))
  };

  getTimeZone = (id: number) => this.data.find((elem) => elem.id === id);

  getMinutesOffset = (offset: string) => {
    if (offset === 'Z') return 0;
    
    const split = offset.split(':');
    const hours = +split[0];
    const minutes = +split[1];

    return hours * 60 + minutes;
  }

  get timeZonesIds() {
    return this.data.map((elem) => elem.id);
  }

  getStringifyTimeZone = (timeZonesId: number) => {    
    const timeZone = this.data.find((elem) => elem.id === timeZonesId);
    return `${timeZone?.name} ${timeZone?.popularCity}`;
  }

  getTimeZoneIdFromOffset = (offset: string) => this.data.find((elem) => elem.zoneOffset === offset);
}
